<template>
  <v-container
    fluid
  >

    <!-- Settings List -->
    <v-row class="pb-10">
      <v-col cols="12">
        <v-list
        >
          <v-subheader>Login Information</v-subheader>
          <v-list-item
            v-ripple>
            <v-list-item-content @click="passwordChangeDialog = true">
              <v-list-item-title>Password</v-list-item-title>
              <v-list-item-subtitle>Click here to change your password</v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>

          <v-list-item
            v-ripple>
            <v-list-item-content>
              <v-list-item-title>Your Details on {{ schoolName }}</v-list-item-title>
              <v-list-item-subtitle><b>{{ caregiverDetails.name }}</b></v-list-item-subtitle>
              <v-list-item-subtitle><b>Mobile:</b> {{ caregiverDetails.mobile }}</v-list-item-subtitle>
              <v-list-item-subtitle><b>Email:</b> {{ caregiverDetails.email }}</v-list-item-subtitle>

            </v-list-item-content>
          </v-list-item>

          <v-subheader v-if="showNotificationsSettings">Notification settings</v-subheader>
          <v-list-item
            v-ripple
            v-if="showNotificationsSettings">
            <v-list-item-action>
              <v-checkbox
                color="primary"
                v-model="notifCheckbox"
                @change="toggleSubscription()"/>
            </v-list-item-action>
            <v-list-item-content @click="toggleSubscription()">
              <v-list-item-title>Enable Notifications</v-list-item-title>
              <v-list-item-subtitle>Be notified when new content is available to view</v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
          <v-list-item
            v-ripple
            @click="toggleEmailSubscription()">
            <v-list-item-action>
              <v-checkbox
                color="primary"
                v-model="emailNotificationCheckbox"/>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>Enable Email Notifications</v-list-item-title>
              <v-list-item-subtitle>Be notified by email when new content is available to view</v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>

          <v-subheader >Shared Schools</v-subheader>
          <template v-if="sharedMultipleUsers.length!=0">
            <v-list
            >
              <v-list-item-group
                color="primary"
              >
                <v-list-item
                  v-for="(userdetails,id ) in sharedMultipleUsers"
                  :key="id">
                  <!-- <v-list-item-content @click="switchSchool(userdetails)"> -->
                  <v-list-item-content>
                    <v-list-item-title><b>{{ userdetails.schoolName }}</b></v-list-item-title>
                    <!-- <v-list-item-subtitle>Click here to switch school</v-list-item-subtitle> -->
                    <v-list-item-subtitle>Login: {{ userdetails.pupilName }}</v-list-item-subtitle>
                  </v-list-item-content>
                  <v-list-item-action>

                    <v-menu
                      bottom
                      left
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          icon
                          v-bind="attrs"
                          v-on="on"
                        >
                          <v-icon>mdi-dots-vertical</v-icon>
                        </v-btn>
                      </template>

                      <v-list>
                        <v-list-item @click="switchSchool(userdetails)">
                          <v-list-item-title>Log in</v-list-item-title>
                        </v-list-item>
                        <v-list-item>
                          <v-list-item-title @click="removeSchoolDialog(userdetails)">Remove</v-list-item-title>
                        </v-list-item>

                      </v-list>
                    </v-menu>

                  </v-list-item-action>

                </v-list-item>
              </v-list-item-group>

            </v-list>
          </template>

          <v-list-item
            v-ripple
            @click="openSchoolDialog()">
            <v-list-item-content >
              <v-list-item-title>Add New School</v-list-item-title>
              <v-list-item-subtitle>Click here to add new school</v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>

        </v-list>
      </v-col>
    </v-row>

    <!--  add new school -->
    <new-school
      :add-school-dialog="addSchoolDialog"
      @closednewschool="closednewschool"
      :reauthentication="reauthentication"
      :shared-user-id="sharedUserId"
    />

    <!-- error dialog -->
    <v-dialog
      v-model="errorDialogSchool"
      width="500">
      <v-card>
        <v-card-title
        >
          Error
        </v-card-title>
        <v-divider/>

        <v-row>
          <v-col>
            <v-card-text>
              {{ switchSchoolError }}
            </v-card-text>
          </v-col>
        </v-row>

        <v-divider/>
        <v-card-actions>
          <v-spacer/>
          <v-btn
            color="primary"
            text
            @click="errorDialogSchool = false">
            Close
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Change Password Dialog -->
    <change-password
      :password-change-dialog="passwordChangeDialog"
      @closedialog="passwordChangeDialog = false" />

    <!-- Terms of Service and Privacy Statement Dialog -->
    <v-dialog
      v-model="termsOfServiceDialog"
      width="500">
      <v-card>
        <v-card-title
          class="headline grey lighten-2"
          primary-title>
          Terms of Service
        </v-card-title>
        <v-card-text>
          <p>This Parent App (the Service) has been created for parents and legal caregivers of students attending {{ schoolName }}. Every user must have a child actively enrolled at {{ schoolName }}.</p>

          <p>I affirm that I am the parent or other person having legal access to educational records for this child.</p>

          <p>I authorise {{ schoolName }} to post my child’s information on the Service. If I do not agree with these terms or do not want the Service to be used for my child, I will inform the school and they will close off access.</p>

          <p>I understand that my access to the Service will be withdrawn 3 months after my child has been withdrawn from the school.</p>

          <p><strong>I agree to be bound by the following terms:</strong></p>

          <p>I will practice proper and ethical use of the Service:</p>
          <ol>
            <li>I agree that I will not share my password nor allow anyone other than myself to use the account.</li>
            <li>The use of this site by individuals other than me is not allowed and can result in the deletion of my account and deactivation of the Service.</li>
            <li>I will not harm or destroy nor attempt to harm or destroy the network, data or data of another user.</li>
            <li>I will not gain unauthorised access to information or use any account of another user, nor will I attempt to gain unauthorised access or attempt to use any account of another user.</li>
            <li>In the event I identify a security problem within the parent portal system, I will notify {{ schoolName }} immediately without demonstrating the problem to anyone else.</li>
          </ol>
          <br>
          <p>In the interests of security, {{ schoolName }} reserves the right to withdraw access from specific users, change user passwords or deny access at any time.</p>

          <p>Information accuracy is the joint responsibility of the school, parents and students. {{ schoolName }} will make every attempt to ensure information is accurate and complete. If I discover any inaccurate information I will notify {{ schoolName }} immediately and provide proof of the inaccurate information.</p>

          <p>I understand that the Service is provided ‘as-is’, without warranty of any kind and at my sole risk. I release {{ schoolName }} and the creators of the Service, eTAP Ltd, from any and all liability for damages or harm, including arising out of unauthorised access to the Service.</p>

          <p>These terms and conditions may be updated from time to time. The date of the most recent revisions will appear on this page. I agree to be bound by the updated terms.</p>

          <p>If I do not want logon/password details sent to my email address I should contact the school to arrange another method of collecting this information.</p>

          <p>Last Revision: Friday 15th, March, 2019</p>
        </v-card-text>
        <v-divider/>
        <v-card-actions>
          <v-spacer/>
          <v-btn
            color="primary"
            text
            @click="termsOfServiceDialog = false">
            Close
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="privacyDialog"
      width="500">
      <v-card>
        <v-card-title
          class="headline grey lighten-2"
          primary-title>
          Privacy Statement
        </v-card-title>
        <v-card-text>
          <p>Information collected by this Parent App (the Service) is used solely to provide information to you and maintain the effective functioning of the Service.  It is not collected for any other reason. It is not provided to any other party unless required to provide the Service.  This Service will never sell or rent any school, student or parent information.</p>

          <p>It may be used to investigate, prevent, and detect activities on the Service that we believe may violate the law or applicable regulations. We may, at the request of a school, investigate accounts to determine whether they comply with school policies and the terms of Service.</p>

          <p>The Service can only be viewed by the student, the student’s parents, and the student’s teachers and school leaders. Additionally, the student’s teacher must approve any post made by students before it is shared with parents.</p>

          <p>Some of the entries in the Service may include links to other websites or require you to user other Services (eg a video player). Any personal information you provide on third-party websites or Services is provided directly to that third-party and is subject to that third-party’s policies governing privacy and security. This Privacy Policy does not apply to these websites or Services. The fact that we link to a website is not an endorsement, authorization or representation that we are affiliated with that third-party, nor is it an endorsement of their privacy or information security policies or practices. These other websites may place their own cookies or other files on your computer, collect data or solicit personal information from you, including if you view a video through an embedded video player which is played off our Service, but may appear to still be playing on our Service. We are not responsible for the content or privacy and security practices and policies of third-party websites or Services.</p>

          <p>This privacy statement may be updated from time to time. The date of the most recent revision will appear on this page.</p>

          <p>Last Revision: Friday 15th, March, 2019</p>
        </v-card-text>
        <v-divider/>
        <v-card-actions>
          <v-spacer/>
          <v-btn
            color="primary"
            text
            @click="privacyDialog = false">
            Close
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-footer
      fixed
      color="white">
      <v-row
        class="fill-height"
        align="center"
        justify="space-around"

      >
        <v-btn
          text
          block
          class="text-none"
          @click="termsOfServiceDialog = true">Terms of Service</v-btn>
        <v-btn
          text
          block
          class="text-none"
          @click="privacyDialog = true">Privacy Statement</v-btn>
      </v-row>
    </v-footer>

    <dialog-confirmation
      :delete-dialog="deleteDialog"
      dialog-title="Delete Entry"
      dialog-text="Do you really want to remove this school on your list?"
      cancel-btn-txt="No"
      save-btn-txt="Yes"
      @cancel-btn-dialog="cancelBtnDialog"
      @save-btn-dialog="saveBtnDialog"
    />

  </v-container>
</template>

<script>
import { mapState } from 'vuex'
import ChangePassword from '../components/ChangePassword'
import NewSchool from '../components/NewSchool'
import DialogConfirmation from '../components/DialogConfirmation'

export default {
  data: () => ({
    notifications: false,
    emailNotificationText: false,

    passwordChangeDialog: false,
    isAppleSubscribed: false,
    termsOfServiceDialog: false,
    privacyDialog: false,
    test: {},

    addSchoolDialog: false,

    sharedMultipleUsers: {},
    switchSchoolError: '',
    errorDialogSchool: false,

    reauthentication: false,
    sharedUserId: '',
    deleteDialog: false,
    selectedSchool: '',
    caregiverDetails: {}

  }),

  components: {
    ChangePassword,
    NewSchool,
    DialogConfirmation
  },

  created: function () {
    if (window.ReactNativeWebView) {
      window.ReactNativeWebView.postMessage(this.$store.state.appleSubscriptionToken)
      this.$http.post('https://www.atschool.co.nz/api/v2/caregivers/' + this.$store.state.userId + '/appleSubscriptionStatus', {
        'subscription': this.$store.state.appleSubscriptionToken
      })
        .then(resp => {
          this.isAppleSubscribed = resp.data.subscribed
          this.$store.commit('update_apple_subscription_token', this.$store.state.appleSubscriptionToken)
        })
    } else {
      window.pushHelper.checkSubscription(window.pushHelper.registration)
      this.notifications = window.pushHelper.isSubscribed
      console.log(this.notifications)
      console.log('created')
    }
  },

  mounted: function () {
    // this.$http.get('https://www.atschool.co.nz/api/v2/caregivers/' + this.$store.state.userId + '/getEmailSubscriptionStatus')
    this.$http.get('https://www.atschool.co.nz/api/v2/caregivers/' + this.$store.state.trueUser + '/getEmailSubscriptionStatus')
      .then(resp => {
        this.emailNotificationText = resp.data.subscribed
      })

    setTimeout(() => {
      this.$store.commit('loading', false)
    }, 250)
    this.$store.commit('toggle_dialog', true)
  },

  computed: {
    ...mapState(['appColour']),

    userId: function () {
      return this.$store.state.schoolId + '/' + this.$store.state.pupilId + '/' + this.$store.state.userId
    },
    isAppleSubscribed: function () {
      return this.$store.state.isAppleSubscribed
    },
    notifCheckbox: function () {
      if (window.ReactNativeWebView) {
        return this.isAppleSubscribed
      } else {
        return window.pushHelper.isSubscribed
      }
    },
    emailNotificationCheckbox: function () {
      return this.emailNotificationText
    },

    appleSubscriptionToken: function () { return this.$store.state.appleSubscriptionToken },
    showNotificationsSettings: function () {
      let userAgent = window.navigator.userAgent
      return window.ReactNativeWebView || (!userAgent.match(/iPad/i) && !userAgent.match(/iPhone/i))
    },
    schoolName: function () { return this.$store.state.schoolName }
  },

  methods: {
    checkAgain: function () {
      if (window.ReactNativeWebView) {
        window.ReactNativeWebView.postMessage(this.$store.state.appleSubscriptionToken)
        this.$http.post('/caregivers/' + this.$store.state.userId + '/appleSubscriptionStatus', {
          'subscription': this.$store.state.appleSubscriptionToken
        })
          .then(resp => {
            this.isAppleSubscribed = resp.data.subscribed
            this.$store.commit('update_apple_subscription_token', this.$store.state.appleSubscriptionToken)
          })
      } else {
        window.pushHelper.checkSubscription(window.pushHelper.registration)
        this.notifications = window.pushHelper.isSubscribed
      }
    },
    toggleSubscription: function () {
      // If not subscribed to push notifications, subscribe
      if (window.pushHelper.registration !== null) {
        // this.checkAgain()

        if (this.notifications === false) {
          this.notifications = true
          console.log('subscribing')
          window.pushHelper.subscribe(this.$store.state.userId, this.$store.state.schoolId)
          // window.pushHelper.subscribe(this.$store.state.trueUser, this.$store.state.schoolId)
        } else {
          this.notifications = false
          console.log('unsubscribing')
          window.pushHelper.unsubscribe()
        }
      } else if (window.ReactNativeWebView) { // Apple iOS app notifications
        if (!this.isAppleSubscribed) {
          console.log('subscribing')
          window.ReactNativeWebView.postMessage('subscribeNotifications')
        } else {
          console.log('unsubscribing')
          window.ReactNativeWebView.postMessage('unsubscribeNotifications')
        }
      }
    },

    toggleEmailSubscription: function () {
      this.$http.post('/registerEmailSubscription', {
        'is_active': !this.emailNotificationText,
        // 'caregiverId': this.$store.state.userId,
        'caregiverId': this.$store.state.trueUser,
        'schoolId': this.$store.state.schoolId
      })
        .then(resp => {
          this.emailNotificationText = resp.data.is_active
        })
    },
    openSchoolDialog () {
      // this.getSharedSchools()
      this.addSchoolDialog = true
    },
    closednewschool () {
      this.addSchoolDialog = false
      this.getSharedSchools()
    },
    getSharedSchools () {
      this.$http.get('/school/' + this.$store.state.schoolId + '/sharedUsers')
        .then(resp => {
          this.sharedMultipleUsers = resp.data.sharedUsers
        })
    },
    switchSchool: function (userdetails) {
      var obj = { mainUserId: this.$store.state.userId, school: this.$store.state.schoolId, anotherUserId: userdetails.shared_user_id }
      var sharedschooldata = JSON.stringify(obj)

      this.$http.post('/logInSharedUser', {
        'sharedUser': sharedschooldata
      })
        .then(resp => {
          if (typeof resp.data.error !== 'undefined') {
            this.switchSchoolError = resp.data.error
            if (resp.data.error === 'Code R') {
              this.reauthentication = true
              this.sharedUserId = userdetails.shared_user_id
              this.openSchoolDialog()
            } else {
              this.sharedUserId = ''
              this.reauthentication = false
              this.errorDialogSchool = true
            }
          } else {
            const data = {
              token: resp.data.token,
              userId: resp.data.parent_id,
              parentName: resp.data.parent_name,
              pupilId: resp.data.pupil_id,
              Dbasename: resp.data.dbasename,
              schoolId: resp.data.school_id,
              schoolName: resp.data.school_name,
              appColour: resp.data.app_colour,
              darkToolbar: resp.data.use_dark_toolbar,
              loginId: resp.data.new_user_id
            }

            this.$store.commit('logout')
            this.$store.dispatch('updateLoginState', data)
            this.$store.dispatch('checkUnreadCounts')
            this.$router.replace('/home')
            this.$router.go(0)
          }
        })
    },
    removeSchoolDialog: function (userdetails) {
      this.deleteDialog = true
      this.selectedSchool = userdetails
    },
    removeSchool: function () {
      var obj = { mainUserId: this.$store.state.userId, school: this.$store.state.schoolId, anotherUserId: this.selectedSchool.shared_user_id }
      var sharedschooldata = JSON.stringify(obj)
      this.$store.commit('loading', true)
      this.$http.post('/removeSharedUser', {
        'sharedUser': sharedschooldata
      })
        .then(resp => {
          if (resp.data.message === 'Success') {
            this.getSharedSchools()
          }
        })

      this.$store.commit('loading', false)
    },
    cancelBtnDialog: function () {
      this.deleteDialog = false
    },
    saveBtnDialog: function () {
      this.deleteDialog = false
      /** delete */
      this.removeSchool()
    },
    getUserDetails: function () {
      this.$http.get('/userDetails')
        .then(resp => {
          this.caregiverDetails = resp.data
        })
    }
  },
  beforeRouteEnter (to, from, next) {
    next(vm => {
      vm.$store.commit('toggle_dialog', true)
      vm.$store.commit('loading', true)
      vm.getUserDetails()
      vm.getSharedSchools()
      vm.$store.commit('loading', false)
    })
  }

}
</script>

<style scoped>
.v-list--three-line .v-list-item .v-list-item__action {
  align-self: auto;
}
</style>
